export default __webpack_public_path__ + "static/media/Project-4-SingleProject-MobileDisplay.e980394d.png";